import Comp from './ForgotPage';

export default Comp;
